import React, { useCallback, useContext, useEffect, useState } from 'react'
import { AppContext } from '../../Context'
import { Outlet, useNavigate, useParams} from 'react-router'

import { getRecord, updateRecordQuery } from '../../services/record-services'

export const RecordContext = React.createContext({})

function RecordPage() {
  const { tokenId } = useContext(AppContext)
  const [record, setRecord] = useState(null)
  const [original, setOriginal] = useState(null)

  const navigate = useNavigate()
  const { id } = useParams()

  const steps = [
    {
      url:`/record/${id}/child-info`
    },{
      url:`/record/${id}/employee-contact`
    },{
      url:`/record/${id}/attachment`
    },{
      url:`/record/${id}/signature`
    }
  ]

  const fetchRecord = useCallback( async () => {
    const result = await getRecord(id, recordData)
    if (result.data.getRecord && result.data.getRecord.length > 0) {
      const r = result.data.getRecord[0]
      reloadRecord(r)
    } else {
      navigate('/error/404')
    }
  }, [id])

  useEffect(() => {
    if (id && tokenId) {
      fetchRecord()
    }
  }, [id, tokenId, fetchRecord])

  const setRecordValue = (key, value) => {
    setRecord({
      ...record,
      [key]: value
    })
  }

  const updateRecord = (updateQuery) => {
    if (record && !record.disabled) {
      return updateRecordQuery(record._id, record.status, updateQuery, recordData)
      .then(resp => {
        if(resp.data && resp.data.updateRecord) {
          const r = resp.data.updateRecord
          reloadRecord(r)
        }
        return resp
      })
    }
    return {}
  }

  const reloadRecord = (lastSavedRecord) => {

    // If the file has not the CREATED status (SENT, ...) then the employee cannot update his file anymore :
    if (lastSavedRecord.status !== 'CREATED') {
      lastSavedRecord.disabled = true
    }

    setRecord(lastSavedRecord)
    setOriginal(lastSavedRecord)

  }

  return record ?
      <RecordContext.Provider value={ { parentHistory: navigate, record, setRecord, setRecordValue, original, setOriginal, updateRecord, steps } }>
        <Outlet />
      </RecordContext.Provider>
   : null
}

export default RecordPage

export const recordData = `
  _id
  basageId
  reference
  status
  partnerAnnualNetIncome
  singleParent
  babysittingMode
  specialContract
  hoursType
  startDate
  child {
    id
    ageCategory
    expired
    dateOfBirth
    firstName
    lastName
  }
  attachments {
    category
    key
    name
    size
    mimetype
    audited
    auditedBy
    auditOk
  }
  events {
    date
    type
    owner
    message
  }
  auditOkDate
  auditKoDate
`

